module.exports = "/_next/static/images/1e76e62528bf5b7b972172726f08dc05-savingsbanner-lg-2x.jpg";